import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MapSettings {
  zoom: number;
  layer: string;
  setZoom: (zoom: number) => void;
  setLayer: (layer: string) => void;
}

interface MapSettingsProviderProps {
  children: ReactNode;
}

const MapSettingsContext = createContext<MapSettings | undefined>(undefined);

export const MapSettingsProvider: React.FC<MapSettingsProviderProps> = ({ children }) => {
  const [zoom, setZoom] = useState(13);
  const [layer, setLayer] = useState('Default Map');

  return (
    <MapSettingsContext.Provider value={{ zoom, layer, setZoom, setLayer }}>
      {children}
    </MapSettingsContext.Provider>
  );
};

export const useMapSettings = () => {
  const context = useContext(MapSettingsContext);
  if (!context) {
    throw new Error('useMapSettings must be used within a MapSettingsProvider');
  }
  return context;
};
